import React from 'react';
import { Chip } from '@mui/material';

const StatusChip = ({ status }) => {
  const statusConfig = {
    PENDING: { color: 'default', label: 'Pending' },
    PROCESSING: { color: 'primary', label: 'Processing' },
    COMPLETED: { color: 'success', label: 'Completed' },
    FAILED: { color: 'error', label: 'Failed' },
    VALIDATED: { color: 'info', label: 'Validated' }
  };
  
  const config = statusConfig[status] || { color: 'default', label: status };
  
  return (
    <Chip 
      size="small" 
      label={config.label} 
      color={config.color} 
    />
  );
};

export default StatusChip;